import React from 'react';
import { Counsellor } from '../../types/counsellor';
import { Box, Typography, Alert } from '@mui/material';
import ReferenceManagement from '../shared/ReferenceManagement';

interface RefereeInformationProps {
  counsellor: Counsellor;
  isAdmin?: boolean;
}

const RefereeInformation: React.FC<RefereeInformationProps> = ({ counsellor, isAdmin = false }) => {
  // Function to refresh counsellor data if needed
  const handleRefresh = () => {
    // This would typically fetch updated counsellor data
    // For now, we'll just use a placeholder as the parent component should handle refreshing
    console.log('Refresh requested from RefereeInformation');
    // In a real implementation, you might call a parent function passed as a prop
  };

  // Check if interview has been accepted - show references from this point onwards permanently
  const showReferences = counsellor.applicationStatus === 'Interview Completed' || 
                         counsellor.applicationStatus === 'Legal Info Requested' ||
                         counsellor.applicationStatus === 'Legal Info Submitted' ||
                         counsellor.applicationStatus === 'Legal Info Update Requested' ||
                         counsellor.applicationStatus === 'Legal Info Approved' ||
                         counsellor.applicationStatus === 'Legal Info Rejected' ||
                         counsellor.applicationStatus === 'Onboarding Review' ||
                         counsellor.applicationStatus === 'Ready For Onboarding' ||
                         counsellor.applicationStatus === 'Accepted' ||
                         counsellor.applicationStatus === 'Active';

  return (
    <Box sx={{ width: '100%', mb: 4 }}>
      <div className="glass-card p-6 rounded-lg">
        {showReferences ? (
          <ReferenceManagement
            counsellorId={counsellor._id}
            counsellorData={counsellor}
            isAdmin={isAdmin}
            onRefresh={handleRefresh}
          />
        ) : (
          <div className="glass-card-light p-4 rounded-lg mb-2">
            <Typography variant="h6" className="theme-text-primary" gutterBottom>
              References
            </Typography>
            <Alert severity="info">
              Reference management will be available after your interview has been completed and accepted.
              You will be able to view the status of your references and see when they have been submitted.
            </Alert>
          </div>
        )}
      </div>
    </Box>
  );
};

export default RefereeInformation;
